// import Vue from 'vue'
import axios from 'axios/index'
// import SQL from 'sql.js'
import getQuestionScore from './get-question score'

const sortQuestions = function (a, b) {
  let nameA = parseInt(a.questionOrder)
  let nameB = parseInt(b.questionOrder)
  if (nameA < nameB) {
    return -1
  }
  if (nameA > nameB) {
    return 1
  }
  return 0
}

const state = {
  examData: {},
  examQuestions: [],
  answeredQuestions: 0,
  examQuestionsCount: 0,
  examCompleteDialogFailStatus: false,
  submittingScoreDialogStatus: false,
  examCompleteDialogPassStatus: false,
  examCompleteData: {},
  examQuestionsLoader: false
}

const getters = {
  getExamData (state) {
    return state.examData
  },
  getExamQuestions (state) {
    return state.examQuestions
  },
  getExamQuestionsCount (state) {
    return state.examQuestionsCount
  },
  getAnsweredQuestions (state) {
    return state.answeredQuestions
  },
  getExamCompleteDialogFailStatus (state) {
    return state.examCompleteDialogFailStatus
  },
  getExamCompleteDialogPassStatus (state) {
    return state.examCompleteDialogPassStatus
  },
  getExamCompleteData (state) {
    return state.examCompleteData
  },
  getSubmittingScoreDialogStatus (state) {
    return state.submittingScoreDialogStatus
  },
  getExamQuestionsLoader (state) {
    return state.examQuestionsLoader
  }
}

const actions = {
  fetchBadgeFrontImageNew ({ dispatch, state, commit, rootGetters }, data) {
    return axios({
      url: process.env.API_URL + `/ws/recall/badge/course/${data.deckId}/user/${data.userId}/front/new`,
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + rootGetters.token
      },
      responseType: 'arraybuffer'
    })
  },
  fetchBadgeBackImageNew ({ dispatch, state, commit, rootGetters }, data) {
    return axios({
      url: process.env.API_URL + `/ws/recall/badge/course/${data.deckId}/user/${data.userId}/back/new`,
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + rootGetters.token
      },
      responseType: 'arraybuffer'
    })
  },
  fetchBadgeFrontImage ({ dispatch, state, commit, rootGetters }, data) {
    return axios({
      url: process.env.API_URL + `/ws/recall/badge/course/${data.deckId}/user/${data.userId}/front`,
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + rootGetters.token
      },
      responseType: 'arraybuffer'
    })
  },
  fetchBadgeBackImage ({ dispatch, state, commit, rootGetters }, data) {
    return axios({
      url: process.env.API_URL + `/ws/recall/badge/course/${data.deckId}/user/${data.userId}/back`,
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + rootGetters.token
      },
      responseType: 'arraybuffer'
    })
  },
  fetchCertificateImage ({ dispatch, state, commit, rootGetters }, data) {
    return axios({
      url: process.env.API_URL + `/ws/recall/certificate/course/${data.deckId}/user/${data.userId}`,
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + rootGetters.token
      },
      responseType: 'arraybuffer'
    })
  },
  sendCertificateMail ({ dispatch, state, commit, rootGetters }, badgeId) {
    // const badgeId = state.examCompleteData.badge.id
    return axios({
      url: process.env.API_URL + `/ws/recall/email/NONE/certificate/${badgeId}`,
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + rootGetters.token
      },
      responseType: 'arraybuffer'
    })
  },
  sendBadgeMail ({ dispatch, state, commit, rootGetters }, data) {
    const emails = data.emails.length === 0 ? 'NONE' : data.emails
    return axios({
      url: process.env.API_URL + `/ws/recall/email/${emails}/badge/${data.badgeId}`,
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + rootGetters.token
      },
      responseType: 'arraybuffer'
    })
  },
  fetchExamQuestions ({ dispatch, state, commit, rootGetters }, examId) {
    commit('setExamQuestionsLoader', true)
    axios({
      url: process.env.API_URL + `/ws/recall/exam/${examId}/question`,
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + rootGetters.token
      }
    }).then(response => {
      commit('setExamQuestionsCount', response.data.questions.length)
      let questions = response.data.questions.filter(question => question.state === 'NOT_PRESENTED')
      questions.sort(sortQuestions)
      commit('setExamQuestions', questions)
      let answered = 0
      response.data.questions.forEach(question => {
        if (question.state === 'ANSWERED') { answered++ }
      })
      commit('setAnsweredQuestions', answered)
      commit('setExamQuestionsLoader', false)
    })
  },
  fetchExamScore ({ dispatch, state, commit, rootGetters }, gameData) {
    commit('setExamQuestionsLoader', true)
    axios({
      url: process.env.API_URL + `/ws/recall/exam/schedule/${gameData.scheduleId}/member/${gameData.memberId}`,
      method: 'POST',
      headers: {
        Authorization: 'Bearer ' + rootGetters.token
      }
    }).then(response => {
      commit('setExamData', response.data)
      dispatch('fetchExamQuestions', response.data.id)
    })
  },
  markFinalExamComplete ({ dispatch, state, commit, rootGetters }, examId) {
    axios({
      url: process.env.API_URL + `/ws/recall/exam/${examId}/complete`,
      method: 'POST',
      headers: {
        Authorization: 'Bearer ' + rootGetters.token
      }
    }).then(response => {
      if (response.data.badge !== null) {
        commit('setExamCompleteDialogFailStatus', false)
        commit('setExamCompleteDialogPassStatus', true)
      } else {
        commit('setExamCompleteDialogFailStatus', true)
        commit('setExamCompleteDialogPassStatus', false)
      }
      commit('setExamCompleteData', response.data)
    })
  },

  validateAnswer ({ dispatch, state, commit, rootGetters }, gdata) {
    commit('setSubmittingScoreDialogStatus', true)
    let answers = []
    gdata.question.answers.forEach(answer => {
      let ans = {
        answer_id: answer.id,
        is_correct: answer.correctEntry,
        text: answer.text
      }
      answers.push(ans)
    })

    const score = getQuestionScore({
      questionId: gdata.question.questionId,
      questionType: gdata.question.type,
      scoreValue: gdata.question.scoreValue,
      answers: answers
    }, gdata.answer)

    let postData = {}
    if (gdata.question.type === 0 || gdata.question.type === 2) { // TF,MC
      postData = {'questionScores': [
        {
          'questionId': gdata.question.id,
          'scoredValue': score.scoredValue,
          'reponseText': null,
          'state': 2,
          'answers': score.examAnswerData
        }
      ]}
    } else if (gdata.question.type === 1) { // FITB
      postData = {'questionScores': [
        {
          'questionId': gdata.question.id,
          'scoredValue': score.scoredValue,
          'reponseText': gdata.answer.toLowerCase(),
          'state': 2,
          'answers': score.examAnswerData
        }
      ]}
    }

    const examId = state.examData.id
    axios({
      url: process.env.API_URL + `/ws/recall/exam/${examId}/score`,
      method: 'POST',
      data: postData,
      headers: {
        Authorization: 'Bearer ' + rootGetters.token
      }
    }).then(response => {
      commit('setSubmittingScoreDialogStatus', false)
      if (response) {
        let questions = [...state.examQuestions]
        questions.splice(gdata.qIndex, 1)
        commit('setExamQuestions', questions)

        if (state.examQuestions.length === 0) {
          dispatch('markFinalExamComplete', examId)
        }
      } else {
        Error('Test set not found!')
      }
    }).catch(error => {
      commit('setSubmittingScoreDialogStatus', false)
      commit('flashError', error.message, { root: true })
    })
  }
}
const mutations = {
  setExamData (state, data) {
    state.examData = data
  },
  setExamQuestions (state, data) {
    state.examQuestions = data
  },
  setExamQuestionsCount (state, count) {
    state.examQuestionsCount = count
  },
  setAnsweredQuestions (state, data) {
    state.answeredQuestions = data
  },
  setExamCompleteDialogFailStatus (state, status) {
    state.examCompleteDialogFailStatus = status
  },
  setSubmittingScoreDialogStatus (state, status) {
    state.submittingScoreDialogStatus = status
  },
  setExamCompleteDialogPassStatus (state, status) {
    state.examCompleteDialogPassStatus = status
  },
  setExamCompleteData (state, data) {
    state.examCompleteData = data
  },
  setExamQuestionsLoader (state, flag) {
    state.examQuestionsLoader = flag
  }
}
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/exam.js